import Vue from 'vue';
import Router from 'vue-router';
import { constantRouterMap } from '@/config/router.config';
var originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(function (err) {
    return err;
  });
};

Vue.use(Router);
var router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: function scrollBehavior() {
    return {
      y: 0
    };
  },
  routes: constantRouterMap
});
export default router;